import Link from "next/link";
const ButtonUi = (props) => {
  return (
    <>
      <div className={props.button_class}>{props.children}</div>
    </>
  );
};
export default ButtonUi;
